import styled from "styled-components";

export const PaintGrey = styled.span `
    color: grey;
    font-size: small;
`;